/**
 * Get the base URL for the application based on environment
 *
 * In development (localhost), returns http://localhost:3000
 * In production, returns https://cnfauto.com
 *
 * This ensures all URLs (payment links, webhooks, etc.) use the correct domain
 */
export const getBaseUrl = (): string => {
  const hostname = window.location.hostname;
  const isDevelopment = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isDevelopment) {
    // Development environment
    const port = window.location.port || '3000';
    return `http://localhost:${port}`;
  }

  // Production environment
  return 'https://cnfauto.com';
};

/**
 * Get the API base URL
 * Returns the backend API URL based on environment
 */
export const getApiBaseUrl = (): string => {
  const hostname = window.location.hostname;
  const isDevelopment = hostname === 'localhost' || hostname === '127.0.0.1';

  if (isDevelopment) {
    return 'http://localhost:3001';
  }

  // Production - adjust if your API is on a different domain
  return 'https://cnfauto.com';
};

/**
 * Check if running in development mode
 */
export const isDevelopmentMode = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
};
